import IntervalSelection from './IntervalSelection'

export default IntervalSelection
